import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

const forEach = require('lodash/forEach');

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            categories: []
        }
    },
    getters: {
        categories: (state) => {
            return state.categories;
        }
    },
    mutations: {
        setCategories(state, value) {
            window.Vue.set(state, 'categories', value);
        },
        pushCategory(state, value) {
            let categories = state.categories;

            categories.push(value);

            window.Vue.set(state, 'categories', categories);
        },
        updateCategory(state, value) {
            forEach(state.categories, (item, key) => {
                if (item.id == value.id) {
                    window.Vue.set(state.categories, key, value);
                    return;
                }
            });
        },
        removeCategory(state, value) {
            let categories = state.categories.filter(
                (category) => {
                    return value.id != category.id
                }
            );

            window.Vue.set(state, 'categories', categories);
        },
    },
    actions: {
        createCategory({commit}, category) {
            return new Promise((resolve, reject) => {
                ApiService.post('/admin/news-category', category)
                    .then((response) => {
                        resolve(response);
                        commit('pushCategory', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editCategory({commit}, category) {
            return new Promise((resolve, reject) => {
                ApiService.update('/admin/news-category/'+category.id, category)
                    .then((response) => {
                        resolve(response);
                        commit('updateCategory', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteCategory({commit}, category) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/admin/news-category/' + category.id)
                    .then((response) => {
                        resolve(response);
                        commit('removeCategory', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getCategories({commit}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/news-category')
                    .then((response) => {
                        resolve(response);
                        commit('setCategories', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    }
};
